export default __webpack_public_path__ + "static/charlotte-crown-white-8f2c7fcaa6413c6aae00b9f077c1fccd.svg";